export class VertexBuffer {
  public itemSize: number;
  public itemCount: number;

  constructor(
    public glVertexBuffer: WebGLBuffer,
    public glDrawMode: number,
    size = 0,
    count = 0,
  ) {
    this.itemCount = count;
    this.itemSize = size;
  }

  public getIndexElementType(gl: WebGL2RenderingContext): number {
    return this.itemCount > 65535 ? gl.UNSIGNED_INT : gl.UNSIGNED_SHORT;
  }
}
